const validateRuleName = ruleName => Boolean(ruleName);

export default validateRuleName;



// WEBPACK FOOTER //
// ./src/state/validateRuleName.js